import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { getAttendeeDetails, updateAttendeeById, logAttendeeBadgePrint } from '../SelfRegistration/actions'
import { Stepper, Step, StepLabel } from "@material-ui/core";
import useWindowDimensions from '../hooks/useWindowDimensions';
import { makeStyles } from '@material-ui/styles';
import { Grid, TextField, Button, Typography } from '@material-ui/core';
//import {motion} from "framer-motion"
import { motion } from "framer-motion/dist/framer-motion";
import * as bpac from 'bpac-react';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(6)
  }
}));

/*
const defaultProps = {
  m: 1,
  border: 1,
  style: { width: '40vw', height: '45vh' },
  alignItems: 'center',
  justifyContent: 'center',
  display: "flex",
  //bgcolor:"lightgreen"
};
*/

const SelfRegistrationKeyboard = props => {


  const { width } = useWindowDimensions();
  const { className, ...rest } = props;
  const classes = useStyles();


  const [attendee, setAttendee] = useState(null);
  const [celular, setCelular] = useState("");
  const [attendeeName, setAttendeeName] = useState("");
  const [tieneCelular, setTieneCelular] = useState(true);  
  const [attendeeMessage, setAttendeeMessage] = useState("Por favor, acerque el código QR al lector");
  //const [event, setEvent] = useState({});
  const [step, setStep] = useState(0);
  const [guid, setGuid] = useState("");
  //const [guidPre, setGuidPre] = useState("");
  //const [attendeeid, setAttendeeId] = useState("");
  const [categoria, setCategoria] = useState("");
  const [event, setEvent] = useState("");
  //const [externalId, setExternalId] = useState("");


  const messages = ["Muestra el código QR que te enviamos por correo electrónico durante tu registro en linea",
    "Toma la etiqueta de la impresora y pegala en el gafete",
    "Listo!"
  ];

  const inputReference = useRef(null);

  const handleChange = async (event) => {
    let data = event.target.value;
    if (event.target.name === "guid")
      setGuid(data);

    if (data) {
      if (step === 0 && data.length >= 36) {

        try {
          
          var attendee_guid = data.substring(0, 36);

          let attendee = (await getAttendeeDetails(attendee_guid)).data;

          if (!attendee) {
            setAttendeeMessage("El usuario no esta registrado en el evento 😔");
            return setTimeout(() => window.location.reload(false), 6000);
          }
          
          setAttendee(attendee);
          setCelular(attendee.celular || "");

          const nombre = `${attendee.nombres} ${attendee.apellidos}`;
          setAttendeeName(nombre);
          setAttendeeMessage(`Bienvenido ${nombre} 👏`);

          setCategoria(attendee.categoria);
          setEvent(attendee.event);

          if (!attendee.celular) {
            console.log(attendee.celular);
            setTieneCelular(false);
            return;
          }

          setStep(1);


          await Promise.all([
          printBadge(attendee),
          logAttendeeBadgePrint(attendee._id, attendee_guid)
          ]);
          setTimeout(() => window.location.reload(false), 6000);
        }
        catch (error) {
          console.log(error);
          setAttendeeMessage("Error! no fue posible procesar la entrada 🛑");
          setTimeout(() => window.location.reload(false), 6000);
        }
      }
    }
  }


  const handleSave = async () => {
    if (celular && celular !== "") {
      try {
        setStep(1);
  
        const celularToUpdate = { celular };
        const attendeeId = attendee._id;
  
        await Promise.all([
          printBadge(attendee),
          updateAttendeeById(attendeeId, celularToUpdate),
          logAttendeeBadgePrint(attendeeId, guid)
        ]);
      } catch (error) {
        console.error(error);
        setAttendeeMessage("Error! no fue posible procesar la entrada 🛑");
      } finally {
        setTimeout(() => window.location.reload(false), 6000);
      }
    }
  };

  const printBadge = async (attendee) => {
    const id = attendee._id;
    const nombres = getDisplayName(attendee.nombres, attendee.apellidos);
    const nombreEmpresa = attendee.nombreEmpresa;

    if (id) {
      const objDoc = bpac.IDocument;
      const ret = await objDoc.Open("https://exmis.apptl.mx/qrglobal.lbx");

      if (ret === true) {
        // Set the text in a Text object inside your template file
        (await objDoc.GetObject("QR")).Text = id;
        (await objDoc.GetObject("Nombre")).Text = nombres;
        (await objDoc.GetObject("Empresa")).Text = nombreEmpresa;

        // Start the print
        await objDoc.StartPrint('', 0);
        await objDoc.PrintOut(1, 0);
        await objDoc.EndPrint();
        await objDoc.Close();
      }
    }
  }

  const handleError = err => {
    console.error(err)
  }


  useEffect(() => {
    inputReference.current.focus();
  }, [])

  const previewStyle = {
    width: (width < 768) ? '50%' : '30%'
  }

  const getDisplayName = (names, lastnames) => {
    if (!names || typeof names !== "string") return "";
    if (!lastnames || typeof lastnames !== "string") return "";

    const firstName = names.trim().split(/\s+/)[0] || "";
    const firstLastName = lastnames.trim().split(/\s+/)[0] || "";

    return `${firstName} ${firstLastName}`.trim();
}


  return (
    <div className={classes.root}>
      <Grid
        container
        direction="column"
        justifyContent="center"
        alignItems="stretch"
      >
        <Grid item xs={12}>
          <div align="center">
            <Typography variant="h1">
              Bienvenido! Por favor sigue las instrucciones mostradas en pantalla para realizar 
            </Typography>
            <br></br>
          </div>
        </Grid>
        <Grid item xs={12}>
          <div align="center">
            <Stepper alternativeLabel activeStep={step}>
              <Step>
                <StepLabel>Acerca el código QR que te enviamos por correo electrónico durante tu registro en linea al lector</StepLabel>
              </Step>
              <Step>
                <StepLabel>Toma la etiqueta de la impresora y pegala en el gafete</StepLabel>
              </Step>
              <Step completed>
              <StepLabel>Listo!</StepLabel>
              </Step>
            </Stepper>
            <br></br>
          </div>
        </Grid>
        <Grid item xs={12}>
          <div align="center" >
            {step !== 2 ?
              <>
                {step === 0 ?
                  <>
                    { tieneCelular === true ?
                      <>                  
                    <Grid item xs={12}>
                      <Typography variant="h3">
                        Paso {step + 1}. {messages[step]}
                      </Typography>
                      <br></br>
                    </Grid>
                    <Grid item xs={12}>
                      <Typography variant="h1">
                        {attendeeMessage}
                      </Typography>
                      <br></br>
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        autoFocus
                        label=""
                        margin="dense"
                        name="guid"
                        onChange={handleChange}
                        required
                        value={guid}
                        variant="outlined"
                        ref={inputReference}
                        hidden
                      />
                    </Grid>
                      </>
                      :
                      <>
                        <Grid item xs={12}>
                        <br></br>
                      </Grid>
                      <Grid item xs={12}>
                        <Typography variant="h1">
                          Por favor, captura tu numero de celular o telefono para continuar
                        </Typography>
                          <Typography variant="h5">
                          Please, entry for mobile number or phone to continue
                        </Typography>
                        <br></br>
                      </Grid>
                      <Grid item xs={8}>
                        <TextField
                          label="Numero Celular o Telefono/Mobile Number or Phone"
                          variant="outlined"
                          fullWidth
                          value={celular}
                          onChange={(e) => setCelular(e.target.value)}
                          onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                              handleSave();
                            }
                          }}
                          InputProps={{
                            style: {
                              fontSize: "1.5rem",
                              padding: "12px 14px"
                            }
                          }}
                          InputLabelProps={{
                            style: {
                              fontSize: "1.2rem"
                            }
                          }}
                        />
                      </Grid>
                      <br></br>
                      <Grid item xs={4}>
                        <Button
                          variant="contained"
                          color="primary"
                          fullWidth
                          size="large"
                          style={{ fontSize: "1.2rem", padding: "12px 0" }}
                          onClick={handleSave}
                        >
                          Continuar/Continue
                        </Button>
                      </Grid>
                      </>
          }                        
                  </>
                  :
                  <>
                    <motion.div
                      className="box"
                      initial={{ opacity: 0, scale: 0.5 }}
                      animate={{ opacity: 1, scale: 1 }}
                      transition={{
                        default: {
                          duration: 0.3,
                          ease: [0, 0.71, 0.2, 1.01]
                        },
                        scale: {
                          type: "spring",
                          damping: 5,
                          stiffness: 100,
                          restDelta: 0.001
                        }
                      }}
                    >
                      <Grid item xs={12}>
                        <Typography variant="h3" display="inline">
                          Paso {step + 1}. Toma uno de los gafetes de
                        </Typography>&nbsp;
                        <Typography variant="h3" style={{ color: '#8a9597' }} display="inline">
                          <b>COLOR GRIS</b>
                        </Typography>&nbsp;
                        <Typography variant="h3" display='inline'>
                          y pegale la etiqueta que se imprimio
                        </Typography>
                        <br></br>
                        <br></br>
                      </Grid>
                      <Grid item xs={12}>
                        <Typography variant="h1">
                          {attendeeMessage}
                        </Typography>
                        <br></br>
                      </Grid>
                    </motion.div>
                  </>
                }
              </>
              :
              <>
                <motion.div
                  className="box"
                  initial={{ opacity: 0, scale: 0.5 }}
                  animate={{ opacity: 1, scale: 1 }}
                  transition={{
                    default: {
                      duration: 0.3,
                      ease: [0, 0.71, 0.2, 1.01]
                    },
                    scale: {
                      type: "spring",
                      damping: 5,
                      stiffness: 100,
                      restDelta: 0.001
                    }
                  }}
                >
                  <Grid item xs={12}>
                    <Typography variant="h1">
                      Felicidades {attendeeName}! Tu registro fue realizado satisfactoriamente 👏
                    </Typography>
                  </Grid>
                </motion.div>
              </>
            }
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

SelfRegistrationKeyboard.prototype = {
  className: PropTypes.string
};

export default SelfRegistrationKeyboard;


